import { createSlice } from '@reduxjs/toolkit';
import { Distribution_Holder } from '../../generated/mlmbox/types/distribution';

const initialState: { value: Distribution_Holder | null } = {
    value: null,
};

export const holdersSlice = createSlice({
    name: 'holders',
    initialState,
    reducers: {
        setHolders(state, { payload }: { payload: Distribution_Holder }) {
            state.value = payload;
        },
    },
});

export const { setHolders } = holdersSlice.actions;

export default holdersSlice.reducer;
